import { baseAPI } from 'services/baseApi';

export const NotificationApis = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    clientActivityUnseen: builder.query({
      query: () => ({ url: 'notifications/client-activity-unseen', method: 'GET' }),
      providesTags: ['CLIENT_ACTIVITY_UNSEEN']
    }),
    clientActivitySeen: builder.mutation({
      query: (body) => ({ url: 'notifications/client-activity-seen', method: 'PUT', body }),
      invalidatesTags: ['CLIENT_ACTIVITY_UNSEEN']
    }),
    getNotificationList: builder.query({
      query: ({ limit, offset }) => ({
        url: `/notifications?limit=${limit}&offset=${offset}&excludeChat=true`,
        method: 'GET'
      }),
      providesTags: ['NOTIFICATION_LIST']
    }),
    markAsRead: builder.mutation({
      query: ({ id }) => ({
        url: `/notifications/mark-as-read/${id}`,
        method: 'PUT'
      }),
      invalidatesTags: ['NOTIFICATION_LIST']
    }),
    markAllAsRead: builder.mutation({
      query: () => ({
        url: `/notifications/mark-all-as-read`,
        method: 'PUT'
      }),
      invalidatesTags: ['NOTIFICATION_LIST']
    })
  })
});

export const {
  useClientActivityUnseenQuery,
  useClientActivitySeenMutation, useGetNotificationListQuery, useLazyGetNotificationListQuery, useMarkAsReadMutation, useMarkAllAsReadMutation } = NotificationApis;
